export default __webpack_public_path__ + "709c06cb991fb7a90999052d4e5a7ada.png";